module.exports = __webpack_public_path__ + "img/31491590000126.5858760b.png";